import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getAllowedRoutes, isLoggedIn, CheckStore, AuthRoute } from './utils';
import { AppRoutes } from './config';
import 'assets/jss/material-dashboard-pro-react/layouts/adminStyle.js';

import Layout from './layout';
import Pages404 from 'views/NotFound';
import ServerError from 'views/ServerError';
import LoginPage from 'views/auth/LoginPage';
import VerifyLoginPage from 'views/auth/VerifyLoginPage/VerifyLoginPage';
import LiveChatWidget from 'components/LiveChatWidget';

const RedirectWithQuery = ({ to }) => {
    const { search } = useLocation();
    return <Navigate to={to + search} replace />;
};

const App = () => {
    useSelector((state) => state.auth.authUser);

    let allowedRoutes = [];
    if (isLoggedIn()) allowedRoutes = getAllowedRoutes(AppRoutes);

    return (
        <Routes>
            <Route path="/auth/login" element={<AuthRoute component={LoginPage} />} />
            <Route path="/auth/verify" element={<VerifyLoginPage />} />
            <Route path="/login" element={<Navigate to="/auth/login" replace />} />
            <Route path="/verify-login" element={<RedirectWithQuery to="/auth/verify" />} />
            <Route path="/verify_by_link" element={<RedirectWithQuery to="/auth/verify" />} />
            <Route path="/500" element={<ServerError />} />
            <Route path="/" element={<CheckStore component={Layout} />}>
                {allowedRoutes.map((route) => {
                    const {
                        path,
                        component: Component,
                        children,
                        title,
                        permission,
                        ...rest
                    } = route;
                    return (
                        <Route
                            {...rest}
                            path={path}
                            element={
                                <>
                                    <LiveChatWidget />
                                    <Component children={children} />
                                </>
                            }
                        />
                    );
                })}
                <Route
                    path="*"
                    element={
                        <>
                            <LiveChatWidget />
                            <Pages404 />
                        </>
                    }
                />
            </Route>
        </Routes>
    );
};

export default App;
